export default __webpack_public_path__ + "static/speedy5-54684bcb93eda84f177a7a610a77c9f0.svg";